import { formatDate } from "@/lib/utils/formatters";
import { CalendarIcon } from "lucide-react";
import { Skeleton } from "./ui/skeleton";
import { cn } from "@/lib/utils";

interface DateRangeDisplayValue {
  from: string | undefined;
  to: string | undefined;
}

export const DateRangeDisplayValue = ({ from, to }: DateRangeDisplayValue) => {
  const missingData = from == undefined && to === undefined;
  return (
    <>
      <CalendarIcon
        className={cn("size-[1em] inline mr-1 align-middle align-[-1px]", {
          "opacity-25": missingData,
        })}
      />
      {from ? (
        formatDate(from)
      ) : (
        <Skeleton className="w-8 h-4 inline-block align-middle" />
      )}
      <span
        className={cn("text-slate-600 mx-1", {
          "text-slate-200": missingData,
        })}
      >
        -
      </span>
      {to ? (
        formatDate(to)
      ) : (
        <Skeleton className="w-8 h-4 inline-block align-middle" />
      )}
    </>
  );
};
